module.exports = __webpack_public_path__ + "img/pre.b917dd8d.png";